
    import { defineComponent, PropType } from 'vue';
    import { IListItem } from "./types";

    export default defineComponent({
        name: "BulletList",
        props: {
            items: { type: Object as PropType<IListItem[]>, required: true }
        }
    });
